export default __webpack_public_path__ + "static/1882-2274ff19df5ceb2897ace91ebe3ec6e4.gif";